/*
 * Embed mode: the reflection is shown inside the marketing site
 * (wiseowltalks.com) in an iframe. In that mode the app drops its own
 * header/footer chrome, never steals focus (which scrolls the frame),
 * opens account pages in a new tab, and reports its height to the parent
 * so the frame fits the content exactly.
 */

const detect = (): boolean => {
  try {
    if (new URLSearchParams(window.location.search).get("embed") === "1") return true;
    return window.self !== window.top;
  } catch {
    // Reading window.top throws when cross-origin framed, which means we ARE framed.
    return true;
  }
};

const EMBEDDED = typeof window !== "undefined" && detect();

export const isEmbedded = (): boolean => EMBEDDED;

// Let the host page's background show through (see styles/index.css).
if (EMBEDDED && typeof document !== "undefined") {
  document.documentElement.classList.add("wot-embed");
}

/** Open an in-app path (e.g. /sign-up); in a new tab when embedded. */
export const openAppPath = (path: string, navigate: (to: string) => void): void => {
  if (EMBEDDED) {
    window.open(`${window.location.origin}${path}`, "_blank", "noopener");
  } else {
    navigate(path);
  }
};

/** Tell the parent page how tall our content is. */
export const startHeightReporter = (): void => {
  if (!EMBEDDED || window.parent === window) return;
  const post = () => {
    const h = Math.ceil(document.documentElement.getBoundingClientRect().height);
    window.parent.postMessage({ type: "wot-reflect:height", height: h }, "*");
  };
  new ResizeObserver(post).observe(document.documentElement);
  window.addEventListener("load", post);
  post();
};
